import React from "react";

const SitaraSapna = () => {
  // Additional images for Sitara Sapna City
  const additionalImages = [
    "/images/Picture15.png",
    "/images/Picture48.jpg",
    "/images/Picture49.jpg",
  ];

  return (
    <div className="w-[90%] mx-auto py-12 flex flex-col gap-12">
      {/* Top Section: Text and Main Image */}
      <div className="flex flex-col lg:flex-row items-start gap-8">
        {/* Left Text Section */}
        <div className="lg:w-2/3 space-y-6">
          <h2 className="text-3xl font-bold text-gray-800">Sitara Sapna City, Faisalabad</h2>
          <h3 className="text-2xl font-bold text-gray-800 leading-tight">
            Construction Services by PACIFIC BUILDERS (PVT) LTD
          </h3>
          <p className="text-gray-700">
            <strong>Sitara Sapna City</strong> is a premium housing compound located near Allied Hospital in Faisalabad. <strong>PACIFIC BUILDERS (PVT) LTD</strong> successfully executed the construction of modern homes with high-end infrastructure and attention to detail.
          </p>

          <div className="text-lg text-gray-700">
            <p><strong>Scope of Work:</strong> Construction of 100 houses of 10 marla, 15 marla and 1 kanal</p>
            <p><strong>Architect:</strong> Raees Faheem</p>
            <p><strong>Covered Area:</strong> 450,000 sq ft</p>
            <p><strong>Location:</strong> Near Allied Hospital, Faisalabad</p>
            <p><strong>Client:</strong> Sitara Hamza (Private) Limited</p>
            <p><strong>Status:</strong> Complete</p>
          </div>
        </div>

        {/* Right Image Section */}
        <div className="lg:w-1/3">
          <img
            src="/images/Picture14.png"
            alt="Sitara Sapna City Construction"
            className="w-full h-auto rounded shadow"
          />
        </div>
      </div>

      {/* Additional Images Section */}
      {additionalImages.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {additionalImages.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`Sitara Sapna City ${index + 1}`}
              className="w-full h-[200px] rounded shadow"
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default SitaraSapna;
